import { render } from "./USRComponentListEditor.vue?vue&type=template&id=c7c49ff0&scoped=true"
import script from "./USRComponentListEditor.vue?vue&type=script&lang=ts"
export * from "./USRComponentListEditor.vue?vue&type=script&lang=ts"

import "./USRComponentListEditor.vue?vue&type=style&index=0&id=c7c49ff0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c7c49ff0"

export default script